import { IData } from "./DataStructure.js";

export class Data {

    public data: IData = null;

    public async load(url: string) {
        this.data = await e5.load("json", url);
        
        this.data.markers.sort((a, b) => {
            return a.target_x - b.target_x;
        });

        this.data.markers.forEach((m, index) => {
            m.kind = "marker";
            m.index = index;
        });
        this.data.scene.kind = "scene";

        return this.data;
    }
}